import { SUPABASE_ANON_KEY, SUPABASE_FUNCTION_BASE_URL } from './config';

const NEWSLETTER_ENDPOINT = `${SUPABASE_FUNCTION_BASE_URL}/newsletter-signup`;

type NewsletterPayload = {
  email: string;
  source?: string;
};

export async function submitNewsletterSignup(payload: NewsletterPayload): Promise<void> {
  try {
    const response = await fetch(NEWSLETTER_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(SUPABASE_ANON_KEY && { Authorization: `Bearer ${SUPABASE_ANON_KEY}` }),
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let message = `Request failed with status ${response.status}`;
      try {
        const body = (await response.json()) as { error?: string };
        if (body?.error) message = body.error;
      } catch (error) {
        console.warn('Failed to parse newsletter error payload', error);
      }
      throw new Error(message);
    }
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Unable to complete signup');
  }
}
